import { createContext } from "react";

const AlbumContext = createContext();

export default AlbumContext;